import { Box, styled } from "@mui/material";
import AppBar from "../appbar/AppBar";
import Footer from "../footer/Footer";

// Create a custom styled Box component
const ScrollableBox = styled(Box)(({ theme }) => ({
  overflow: 'auto',
  scrollbarWidth: 'thin', /* For Firefox */
  scrollbarColor: 'transparent transparent', /* For Firefox */
  '&::-webkit-scrollbar': {
    width: 0, /* For Chrome, Safari, and Opera */
    background: 'transparent', /* For Chrome, Safari, and Opera */
  },
  '&:active': {
    scrollbarWidth: 'auto', /* For Firefox */
    scrollbarColor: 'darkgray lightgray', /* For Firefox */
  },
  '&:active::-webkit-scrollbar': {
    width: '8px', /* For Chrome, Safari, and Opera */
    background: 'lightgray', /* For Chrome, Safari, and Opera */
  },
  '&:active::-webkit-scrollbar-thumb': {
    background: 'darkgray', /* For Chrome, Safari, and Opera */
  },
}));

function TemplatePage({ component }) {
  return (
    <Box display="flex" flexDirection="column" height="100vh">
      <Box flexShrink={0}>
        <AppBar />
      </Box>
      <ScrollableBox flexGrow={1} mx={4}>
        {component}
      </ScrollableBox>
      <Box flexShrink={0}>
        <Footer appName={"2024 Doctrain"} />
      </Box>
    </Box>
  );
}

export default TemplatePage;